// Import React and Hooks
import React from 'react'
// Import Components
import InputForm from './InputForm'



// Group Form Prop
interface groupFormProp {
  additionalClass?:string,
  groupData:any
}

const GroupForm = ( { additionalClass, groupData }:groupFormProp ) => {



  const { register, errors, inputElements, title } = groupData



  return (
    <div className={`form__group ${ additionalClass ? additionalClass : ''}`}>
			<label className="form__group__title">
				{ title }
			</label>
			{ inputElements.length > 0 && inputElements.map( (inputEl:any) => {

				inputEl = {
					register,
					errors,
					...inputEl
				}

				return <InputForm
					key={ inputEl.id }
					inputData={ inputEl } />

			} ) }
		</div>
  )
}



export default GroupForm
